const Cleat4 = ({ ...props }) => {
  return (
    <svg
      width="16.99979"
      height="16.99999"
      viewBox="0 0 16.99979 16.99999"
      shapeRendering="geometricPrecision"
      preserveAspectRatio="none"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <circle
        cx="13.3694"
        cy="3.6303899"
        r="3.1303899"
        id="circle869"
        fill={props.fill}
      />
      <circle
        cx="3.6303899"
        cy="3.6303899"
        r="3.1303899"
        id="circle871"
        fill={props.fill}
      />
      <circle
        cx="13.3694"
        cy="13.3696"
        r="3.1303899"
        id="circle873"
        fill={props.fill}
      />
      <circle
        cx="3.6303899"
        cy="13.3696"
        r="3.1303899"
        id="circle875"
        fill={props.fill}
      />
    </svg>
  )
}

export default Cleat4
